import {
  Component,
  ComponentRef,
  Input,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewContainerRef,
} from '@angular/core';
import { of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { IRendererModel } from '@types-custom/models/ui/renderer.model';
/*
** Renderer
** Render a container that can be used for render components.
*/
@Component({
  selector: 'sit-renderer',
  templateUrl: './renderer.component.html',
  styleUrls: ['./renderer.component.scss'],
})
export class RendererComponent implements OnInit, OnDestroy {
  @Input() toRender: IRendererModel | undefined;

  @ViewChild('containerRef', { read: ViewContainerRef })
  private containerRef: ViewContainerRef | undefined;


  ngOnInit(): void {
    if (this.toRender) {
      of(this.toRender)
        .pipe(delay(10))
        .subscribe(this.renderElement.bind(this));
    }
  }

  ngOnDestroy(): void {
    this.containerRef?.clear();
  }

  private renderElement(toRender: IRendererModel | undefined): void {
    if (toRender?.component) {
      const cmpRef: ComponentRef<unknown> | undefined =
        this.containerRef?.createComponent(toRender.component);
      this.mapData(cmpRef, toRender.data);
    }
  }

  private mapData(cmpRef: any, data: any): void {
    if (data && cmpRef?.instance) {
      Object.getOwnPropertyNames(data).forEach(
        (attr) => (cmpRef.instance[attr] = data[attr])
      );
    }
  }
}
